import type { PresenceRow } from '@/types/presence';

export function presenceForUserId(
  presenceByUserId: Record<string, PresenceRow>,
  userId: string
): PresenceRow | undefined {
  return presenceByUserId[String(userId)];
}

export function isUserOnline(
  presenceByUserId: Record<string, PresenceRow>,
  userId: string
): boolean {
  return presenceForUserId(presenceByUserId, userId)?.is_online === true;
}
